const BASE_URL = {
  //公共
  public: `${process.env.VUE_APP_API_BASE_URL}`,
};

export default BASE_URL;